import TransportSpecificLinksTitle from "@Header/components/TransportSpecificLinks/TransportSpecificLinksTitle";
import React from "react";
import MenuItem from "@Header/components/TopBar/MenuItem";

interface LocaleSpecificMainMenuItemProps {
    entry: any,
    currentRoute: string,
}

export const LocaleSpecificMainMenuItem = (props: LocaleSpecificMainMenuItemProps) => {
    const {
        entry,
        currentRoute,
    } = props;

    if (entry?.list) {
        return (
            <TransportSpecificLinksTitle
                title={entry.titleKey}
                items={entry.list}
                key={entry.key}
            />
        )
    }

    return (
        <MenuItem
            entry={entry}
            currentRoute={currentRoute}
            visible
            key={entry[0]}
        />
    )
}